<template>
    <div>
        <div class='contents'>
            <section class="hero is-light is-fullheight">
                <div class="hero-body">
                    <div class="container">
                        <div class="columns is-centered">
                            <div class="column is-5-tablet is-4-desktop is-4-widescreen">
                                <form action="" class="box">
                                    <div class='field'>
                                        <label class='label'>パスワード</label>
                                        <div class='control has-icons-left'>
                                            <input class='input' type='password' placeholder='8文字以上256文字以内' minlength='8' maxlength='256' v-model='password' required/>
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class='field'>
                                        <label class='label'>パスワード再入力</label>
                                        <div class='control has-icons-left'>
                                            <input class='input' type='password' placeholder='同一のパスワード' minlength='8' maxlength='256' v-model='retypePassword' required/>
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="button is-success submit" @click='submit'>
                                            送信
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Recovery',
    components: {
    },
    data () {
        return {
            password: '',
            retypePassword: ''
        }
    },
    mounted () {
    },
    methods: {
        submit () {
            const self = this
            if (self.password !== self.retypePassword) {
                self.$root.$emit('notification', 'is-danger', '再入力用のパスワードが一致しません')
                return
            }

            if (!(self.password.length >= 8) || !(self.password.length <= 256)) {
                self.$root.$emit('notification', 'is-danger', 'パスワードは8文字以上256文字以下で入力してください')
                return
            }
            self.axios.post(`${process.env.API_URL}/recovery`, {
                password: self.password,
                token: self.$route.query.token
            }).then((res) => {
                if (res.data.message === 'Failed') {
                    self.$root.$emit('notification', 'is-danger', '該当リンクは既に期限切れです')
                    return
                }

                self.$root.$emit('notification', 'is-primary', 'パスワードの更新に成功しました。5秒後に自動でログインページに戻ります。')
                setTimeout(() => {
                    self.$router.push('/login')
                }, 5000)
            }).catch((e) => {
                self.$root.$emit('notification', 'is-danger', 'サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>
.submit {
    margin-top: 30px;
    width: 100%;
}

.link {
    color: #1a0dab;
}
</style>



// WEBPACK FOOTER //
// src/routes/Recovery.vue